import React from 'react';
import HeroSection from './components/HeroSection';
export function App() {
  return <div className="w-full min-h-screen bg-black text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
    </div>;
}